import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { AlertService } from '../../shared/component/alert-component/alert.service';

export function errorInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const alertService = inject(AlertService);

  return next(req).pipe(
    catchError((error: any) => {
      if (error instanceof HttpErrorResponse) {
        const status = error.status;
        const message =
          error?.error?.message ??
          `We encountered an error while processing your request. (Error code: ${status})`;

        alertService.error(message);
      }
      return throwError(() => error);
    }),
  );
}
